import "../productskeleton/ProductSkeleton.css";

const ProductSkeleton = () => {
  return (
    <div className="pd-skeleton">
      <div className="left">
        <div className="img"></div>
        <div className="thumbs">
          {[1,2,3].map(i => <span key={i}></span>)}
        </div>
      </div>

      <div className="right">
        <div className="line title"></div>
        <div className="line"></div>
        <div className="line price"></div>
        <div className="line desc"></div>
        <div className="line btn"></div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
